<fa-icon
   kendoTooltip
   [title]="'brick.brick_definitions.directory_browser.columns.presence_status_forward_destination.title' | translate"
   [ngClass]="{ 'no-data': !(forwardDestination$ | async) }"
   [icon]="(forwardDestination$ | async) ? forwardIcon : noForwardIcon"
   [fixedWidth]="fixedWidth"
></fa-icon>
{{ forwardDestination$ | async }}
